<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row">
          <i class="fa fa-list"></i>
          <span class="card-label fs-3 ms-1">Nhật ký</span>
        </h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Từ:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên tài khoản" v-model="pageRequest.columnFilters.cTenTaiKhoan.value" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Từ:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select placeholder="Hành động" v-model="pageRequest.columnFilters.nHanhDong.value">
                  <el-option value="" label="Tất cả">Tất cả</el-option>
                  <el-option value="insert" label="Tạo mới"></el-option>
                  <el-option value="update" label="Cập nhật"></el-option>
                  <el-option value="download" label="Xuất"></el-option>
                  <el-option value="delete" label="Xóa"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Từ:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-date-picker v-model="pageRequest.columnFilters.tuNgay.value" placeholder="Chọn ngày" type="date" class="w-100"
                  format="DD/MM/YYYY" value-format="DD/MM/YYYY">
                </el-date-picker>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Đến:</label>
            <div class="d-flex">
              <el-date-picker v-model="pageRequest.columnFilters.denNgay.value" placeholder="Chọn ngày" type="date" class="w-100"
                format="DD/MM/YYYY" value-format="DD/MM/YYYY">
              </el-date-picker>
              <el-button plain type="primary" title="Tìm kiếm" @click="this.findLog(pageRequest.pageNum,pageRequest.pageSize)" class="ms-2"><i
                  class="fa fa-search"></i></el-button>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <h6>Nhật ký dữ liệu</h6>
        </div>
      </div>
      <div class="card-body">
        <div class="tbl">
          <el-table :data="dataLogComputed" style="height: 100%" height="100%" fit
             >
            <el-table-column label="Địa chỉ IP" width="180" prop="cIP"> </el-table-column>
            <el-table-column label="Tên tài khoản" width="180" prop="cTenTK">
            </el-table-column>
            <el-table-column label="Hành động" width="150" align="center">
              <template  #default="scope">
                <el-tag v-if="scope.row.nHanhDong == 1" type="success">
                  <i class="el-icon-plus" :width="16" :height="20" />
                  Tạo mới
                </el-tag>
                <el-tag v-if="scope.row.nHanhDong == 3" type="warning">
                  <i class="el-icon-edit" />
                  Cập nhật
                </el-tag>
                <el-tag v-if="scope.row.nHanhDong == 4" type="danger"><i class="fas fa-trash-alt"></i> Xóa</el-tag>
                <el-tag v-if="scope.row.nHanhDong == 2"><i class="fas fa-cloud-download-alt"></i> Xuất</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Thời gian" width="180">
              <template  #default="scope">
                <span v-if="scope.row.dNgayTao">{{
                  momentDate(scope.row.dNgayTao)
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Mô tả" width="260" prop="cMoTa"> </el-table-column>
            <el-table-column label="Tham số" prop="cThamSo">
              <template  #default="scope">
                <span class="text-nowrap">{{ scope.row.cThamSo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Chi tiết" align="center" width="100">
              <template  #default="scope">
                <el-button type="primary" @click="showDetail(scope.row.cThamSo)" circle style="padding: 6px 8px;">
                  <i class="el-icon-s-comment" style="font-size: 12px;" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination :page-sizes="[5, 10, 20, 30, 50]" background layout="total,sizes,  prev, pager, next"
          :page-size="pageRequest.pageSize" :current-page.sync="pageRequest.pageNum"
          @current-change="handleCurrentChange" @size-change="handleSizeChange" :total="dataLog.totalSize">
        </el-pagination>
      </div>
    </div>

    <el-dialog v-model="showLogDetail" :show-close="false">
      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4">
          <h2 class="fw-bolder">{{ "Chi tiết" }}</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="showLogDetail = false">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>
      <div class="log-container">
        <fieldset>
          <legend>Trước</legend>
          <VueJsonPretty style="padding: 16px;" :data="thamsoTruoc" />
        </fieldset>
        <fieldset>
          <legend>Sau</legend>
          <VueJsonPretty style="padding: 16px;" :data="thamsoSau" />
        </fieldset>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import moment from "moment";
import { useStore } from "vuex";
import { Log } from "@/store/enums/StoreEnums";
export default {
  components: {
    VueJsonPretty,
  },
  computed: {
    dataLogComputed() {
      return this.dataLog.content.map((record) => {
        const d = {
          cTenTK: record.cTenTaiKhoan,
          dThoigian: record.dNgayTao,
          cIP: record.cIp,
          cThamSo: record.cThamSo,
          dNgayTao: record.dNgayTao,
        };
        let table = "";
        switch (record.cThaoTac) {
          case "SysChucNang":
            table = "Chức năng";
            break;
          case "SysNhomQuyen":
            table = "Nhóm quyền";
            break;
          case "SysTaiKhoan":
            table = "Tài khoản";
            break;
          default:
            table = "unknow";
            break;
        }
        let hanhdong = "";
        if (
          record.cHanhDong.startsWith("insert")
        ) {
          d.cMoTa = `Tạo ${table.toLowerCase()} mới`
          d.nHanhDong = 1;

        }
        else if (record.cHanhDong.startsWith("download")) {
          d.nHanhDong = 2;
          switch (record.cHanhDong) {
            case "downloadPDFPhieuThu":
              d.cMoTa = "Xuất phiếu thu .PDF";
              break;
            case "downloadInvoice":
              d.cMoTa = "Tải hóa đơn điện tử .PDF"
          }
        }
        else if (record.cHanhDong.startsWith("update") || record.cHanhDong.startsWith("save")) {
          d.nHanhDong = 3;
          switch (record.cHanhDong) {
            case "saveGhiChiSo":
              d.cMoTa = "Ghi sổ chỉ số";
              break;
            case "updateChiSoMoiHD":
              d.cMoTa = "Cập nhật chỉ số nước tại trang hóa đơn";
              break;
            case "updateHoaDonDT":
              d.cMoTa = "Phát hành hóa đơn điện tử";
              break;
            default:
              d.cMoTa = `Cập nhật ${table.toLowerCase()}`
              break;
          }
        }
        else if (record.cHanhDong.startsWith("delete")) {
          d.nHanhDong = 4;
          d.cMoTa = `Xóa ${table.toLowerCase()}`
        }
        else {
          d.nHanhDong = 3;
          d.cMoTa = record.cHanhDong;
        }
        return d;
      });
    },
  },
  data() {
    return {
      showLogDetail: false,
      pageRequest: {
        pageNum: 1,
        pageSize: 30,
        columnFilters: {
          nHanhDong: { value: "" },
          cTenTaiKhoan: { value: "" },
          tuNgay: { value: moment(Date.now()).format("01/MM/YYYY") },
          denNgay: { value: moment(Date.now()).format("DD/MM/YYYY") },
        },
      },
      dataLog: {
        totalSize: 0,
        content: [],
      },
      thamsoDT: "",
      thamsoTruoc: "",
      thamsoSau: "",
      store: useStore()
    };
  },
  methods: {

    showDetail(val) {
      // console.log(val);
      this.thamsoDT = JSON.parse(val);
      this.thamsoTruoc = this.thamsoDT.old;
      this.thamsoSau = this.thamsoDT.new;
      if (!this.thamsoSau) this.thamsoSau = this.thamsoDT;
      if (!this.thamsoTruoc) this.thamsoTruoc = {};
      this.showLogDetail = true;
    },

    findLog(a, b) {
      this.pageRequest.pageNum = a;
      this.pageRequest.pageSize = b;
      this.store.dispatch(Log.findPageLog, this.pageRequest).then((res) => {
        if (res.code == 200 && res.data)
          this.dataLog = res.data;
        else
          this.dataLog = []
      });
    },


    handleSearch() {
      const tuPart = this.pageRequest.columnFilters.tuNgay.value.split('/');
      const tu = new Date(+tuPart[2], tuPart[1] - 1, +tuPart[0])
      const denPart = this.pageRequest.columnFilters.denNgay.value.split('/');
      const den = new Date(+denPart[2], denPart[1] - 1, +denPart[0])
      if (tu > den || tu > Date.now()) ElMessage({ message: "Mốc thời gian không hợp lệ !", type: "error" })
      else this.findLog(1, 30);
    },


    handleSizeChange(val) {
      this.findLog(this.pageRequest.pageNum, val);
    },
    handleCurrentChange(val) {
      this.findLog(val, this.pageRequest.pageSize);
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
  },
  mounted() {
    this.findLog(1, 30);
  },
};
</script>
<style scoped>
fieldset {
  border: 1px solid rgb(223, 215, 215) !important;
  font-size: 13px !important;
}

fieldset.ttkhachhang {
  height: calc(100% - 36px);
}

legend {
  width: auto !important;
  font-size: 13px !important;
  margin-left: 32px !important;
}

.log-bg {

  /* height: 100vh;
    width: 100vw; */
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
}

.log-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.modal-log__detail {
  margin: auto;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 10px;
  border: 1px #c1c1c1 solid;
  width: 80%;
}

.btn__xacnhan {
  background-color: #66b1ff;
  color: white;
  width: fit-content;
  border-radius: 5px;
  padding: 0px 7px;
  cursor: pointer;
  margin-bottom: 10px;
  margin-left: calc(100% - 100px);
}

.tbl {
  height: calc(100vh - 250px);
}

.item-date-control {
  flex: auto;
  width: auto;
}

.box-card {
  margin: 10px;
}

h6 {
  margin-bottom: 0px;
}
</style>
<style>
.item-date-control .el-input__inner {
  color: #000;
  border: 1px solid #b1b4b8;
  height: 1.6rem;
}

.item-date-control .el-input__icon {
  line-height: 1.6rem;
  height: 1.6rem;
}
</style>
